"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.asyncRetry = void 0;
const utils_1 = require("./utils");
const promises_1 = require("./promises");
const asyncRetry = async (fn, retryOptions, currentRetries = 1) => {
    try {
        return await fn();
    }
    catch (e) {
        const error = (0, utils_1.guaranteedError)(e);
        if (error.name === "SyntaxError" ||
            currentRetries >= retryOptions.maxRetries ||
            retryOptions?.stopRetry?.(error)) {
            console.error(`Async retry failed with error`, (0, utils_1.buildErrorContext)(error));
            throw error;
        }
        await (0, promises_1.sleep)(currentRetries * retryOptions.delayMs);
        return (0, exports.asyncRetry)(fn, retryOptions, currentRetries + 1);
    }
};
exports.asyncRetry = asyncRetry;
//# sourceMappingURL=asyncRetry.js.map